import { configureStore } from "@reduxjs/toolkit";
import {
	login,
	loginCheck,
	profilegetApi,
	cardapi,
	Clientgetapi,
	Notigetapi,
	Transactiongetapi
} from "./action"
const store = configureStore({
	reducer: {
		login,
		loginCheck,
		profilegetApi,
		cardapi,
		Clientgetapi,
		Notigetapi,
		Transactiongetapi
	},
})
export default store